<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-card flat>
        <v-toolbar
          color="primary"
          dark
          flat
          dense
        >
          <v-row>
            <div class="col">
              <div
                class="d-inline-block"
                style="position: absolute; left: 10px; top: 10px"
              >
                <slot name="left" />
              </div>

              <div class="text-center">
                <v-toolbar-title v-text="title" />
              </div>

              <div
                class="d-inline-block"
                style="position: absolute; right: 10px; top: 10px"
              >
                <slot name="right" />
              </div>
            </div>
          </v-row>

          <template v-if="$slots.extension" #extension>
            <slot name="extension" />
          </template>
        </v-toolbar>
        <v-card-text>
          <slot />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'SessionContentContainer',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
}
</script>
